import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/system";
import { Radio, FormControlLabel } from "@mui/material";

import { ICONS, Icon } from "../../Icons/Icon";

export const StyledCustomRadioForm = styled(FormControlLabel)(({ theme }) => ({
  borderRadius: "39px",
  border: "1px solid var(--Color-Text-Primary-On-Light, #1F1F1F)",
  paddingRight: "16px",
  margin: "0",
  "& .label": {
    fontSize: "14px",
    color: theme.palette.text.color
  },
  "& .root": {},
  "& .parent": {},
  outline: "none"
}));

export const CustomIconRadio = ({ color, onSelect, dataTestId, ...restProps }) => {
  return (
    <Radio
      sx={{
        color: color,
        "&.Mui-checked": {
          color: color
        }
      }}
      onClick={onSelect}
      icon={<Icon name={ICONS.unCheckedRadio} alt="select icon" />}
      checkedIcon={<Icon name={ICONS.checkedRadio} alt="selected icon" />}
      data-testid={dataTestId}
      {...restProps}
    />
  );
};

CustomIconRadio.propTypes = {
  color: PropTypes.string,
  onSelect: PropTypes.func,
  dataTestId: PropTypes.string
};

const CustomColorRadio = styled(Radio)(({ theme, radioColor }) => ({
  color: theme.palette.primary.main,
  padding: "8px 4px 8px 8px",
  cursor: "pointer",
  "& .MuiSvgIcon-root": {
    cursor: "pointer",
    pointerEvents: "all"
  },
  "&.Mui-checked": {
    color: radioColor || theme.palette.primary.main
  }
}));

export const CustomRadioButton = ({
  label,
  customIcon = true,
  onSelect = () => {},
  classes: extendedClasses,
  dataTestId,
  ...rest
}) => {
  const { radioColor, ...restProps } = rest;

  return (
    <StyledCustomRadioForm
      classes={{
        label: extendedClasses?.label || "label",
        root: extendedClasses?.root || "root",
        parent: ""
      }}
      control={
        customIcon ? (
          <CustomIconRadio
            color={radioColor}
            onSelect={onSelect}
            dataTestId={dataTestId}
            {...restProps}
          />
        ) : (
          <CustomColorRadio
            onClick={onSelect}
            disableRipple={true}
            data-testid={dataTestId}
            {...restProps}
          />
        )
      }
      label={label}
      tabIndex={0}
    />
  );
};

CustomRadioButton.propTypes = {
  label: PropTypes.string.isRequired,
  customIcon: PropTypes.bool,
  onSelect: PropTypes.func,
  classes: PropTypes.shape({
    label: PropTypes.string,
    root: PropTypes.string,
    parent: PropTypes.string
  }),
  dataTestId: PropTypes.string,
  radioColor: PropTypes.string
};
